import { useEffect, useState } from "react";
import { Filter, Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import {
  ContainerHeader,
  LeadDataTable,
  FormLeadModal,
  FormFilterLeads
} from "@/components/common";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useFetchLeadsQuery } from "@/hooks";
import { Skeleton } from "@/components/ui/skeleton";

export function Leads() {
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const search = searchParams.get("search") || "";
  const source = searchParams.get("source") || "";
  const status = searchParams.get("status") || "";
  const convertedToPatient = searchParams.get("converted_to_patient") || "";
  const startDate = searchParams.get("start_date") || "";
  const endDate = searchParams.get("end_date") || "";

  const [searchInput, setSearchInput] = useState(search);

  const {
    data: leadsData,
    refetch: refetchLeadsData,
    isLoading,
  } = useFetchLeadsQuery({
    page,
    search: searchInput,
    source,
    status,
    converted_to_patient: convertedToPatient,
    start_date: startDate,
    end_date: endDate,
  });

  const handleDelete = () => {
    refetchLeadsData();
  };

  useEffect(() => {
    setTimeout(async () => {
      await refetchLeadsData();
    }, 1500);
  }, [page, search, source, status, convertedToPatient, startDate, endDate]);

  return (
    <section className="space-y-7">
      <div className="space-y-5">
        <div className="space-y-3">
          <h1 className="text-2xl font-semibold tracking-tight text-app-fg-strong">Leads</h1>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink to="/crm/leads">
                  CRM
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>Leads</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
        <ContainerHeader>
          <Input
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            type="search"
            placeholder="Pesquisar leads..."
            showError={false}
            className="max-w-md"
          />
          <div className="flex items-center gap-2">
            <FormFilterLeads>
              <Button variant="secondary" className="flex gap-2 items-center">
                <Filter className="size-3" />
                <span>Filtrar</span>
              </Button>
            </FormFilterLeads>
            <FormLeadModal>
              <Button className="px-10">
                <Plus className="mr-2 h-4 w-4" />
                {t("LABEL.new")}
              </Button>
            </FormLeadModal>
          </div>
        </ContainerHeader>
      </div>
      <div className="space-y-2">
        {!leadsData || isLoading ? (
          <Skeleton className="w-full h-[500px]" />
        ) : (
          <LeadDataTable
            data={leadsData?.items || []}
            paginationData={leadsData?.data}
            onDelete={handleDelete}
          />
        )}
      </div>
    </section>
  );
}